import { DemandServices } from "../../../services";
import { IBaseState } from "../..";
import { IDemandModel } from "../../../models/demand";

export interface IDemandEditState extends IBaseState<DemandServices, {}> {
	service: DemandServices;
	demand?: IDemandModel;
	demandOrigin?: IDemandModel;
	demandForCreate?: IDemandModel;
	isSaving?: boolean;
}

export class DemandEditState implements IDemandEditState {
	service: DemandServices;
	demand: IDemandModel;
	demandOrigin?: IDemandModel;
	demandForCreate: IDemandModel;
	isSaving: boolean;

	constructor(option: IDemandEditState) {
		this.service = option.service;
		this.demand = option.demand;
		this.demandForCreate = option.demandForCreate || null;
		this.demandOrigin = option.demandOrigin || null;
		this.isSaving = false;
	}
}
